import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import { Svg } from './Svg.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { redirectToTwitterWithShortenedUrl } from '../sharebar/sharebarHelperFunctions.js';

// from general.js
/* global dcAnalytics */

// TODO: refactor so we can use modules to populate getTrackingLink
export const TwitterLink = createReactClass({
    propTypes: {
        urlToShare: PropTypes.string.isRequired,
        pageName: PropTypes.string.isRequired,

        getTrackingLink: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired,

        onTwitterClick: PropTypes.func.isRequired,

        // Decides if we should use a <span> and not a <a>. Useful for nesting
        // within a parent <a> such as a ProjectCard.
        useSpan: PropTypes.bool,
        className: PropTypes.string,

        children: PropTypes.node,
    },

    getTrackingLink: function () {
        return this.props.getTrackingLink(this.props.urlToShare, 'twitter', this.props.pageName);
    },

    getTwitterUrl: function (trackingLink) {
        return 'http://www.twitter.com/share?text=' + this.props.text + '&url=' + trackingLink;
    },

    shareIcon: function () {
        if (React.Children.count(this.props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="ss-twitter" iconFamily="social-circle" attributes={{ 'aria-label': 'share on twitter' }}/>
            );
        }
    },

    onClick(event) {
        const trackingLink = this.getTrackingLink();
        dcAnalytics.trackShareToolClick(this.props.pageName, this.props.urlToShare, 'Twitter');
        redirectToTwitterWithShortenedUrl(this.getTwitterUrl(trackingLink), decodeURIComponent(trackingLink));
        event.preventDefault();
        return false;
    },

    render: function () {
        if (this.props.useSpan) {
            return (
                <KeyboardClickable>
                    <span aria-label="Share on Twitter"
                        tabIndex="0"
                        onClick={this.onClick}
                        className={this.props.className + ' heap-twitter-share'}
                    >
                        {this.shareIcon()}
                        {this.props.children}
                    </span>
                </KeyboardClickable>
            );
        } else {
            return (
                <a href={this.getTwitterUrl(this.getTrackingLink())}
                    onClick={this.onClick}
                    target="_blank"
                    aria-label="Share on Twitter"
                    className={this.props.className + ' heap-twitter-share'}
                >
                    {this.shareIcon()}
                    {this.props.children}
                </a>
            );
        }
    },
});
